<template>
  <div class="iv-headImg-wrapper">
    <img class="iv-avatar" :src="headImg">
    <span class="iv-symbol-ml8">{{ params.row[map.name] }}</span>
    <IconFont
      class="iv-symbol-ml8 iv-middle"
      v-for="(item, i) in iconList"
      :key="i"
      v-if="item.value"
      :type="item.icon"></IconFont>
  </div>
</template>

<script>
import imagePath from '@/mixins/image-path'
import IconFont from '@/components/iconfont'
export default {
  mixins: [imagePath],
  name: 'headImg',
  props: ['item', 'params'],
  data () {
    return {
      headImg: ''
    }
  },
  computed: {
    iconList () {
      return Object.entries(this.map.icon).map(([icon, key]) => {
        return {
          value: !!this.params.row[key],
          icon
        }
      })
    }
  },
  created () {
    this.map = this.item.headImgMap
    // this.getImgSrc('headImg', 'headImg', this.params.row[this.map.img])
    this.getImgSrc('headImg', 'headImg')
  },
  components: {
    IconFont
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/base/variable.scss';
  .iv-headImg-wrapper {
    line-height: 22px;
  }
  .iv-avatar {
    width: 22px;
    height: 22px;
    vertical-align: top;
    border-radius: 50%;
    border:1px solid rgba(0,0,0,0.15);
  }
  .iv-middle {
    vertical-align: middle !important;
  }
  .iconfont {
    color: $iv-main-color;
  }
  .icon-liuchu {
    color: $iv-main-color;
  }
  .icon-liuru {
    color: $iv-green-color;
  }
  .icon-shilian {
    color: $iv-fc-65;
  }
</style>
